import { render, staticRenderFns } from "./teaDynamic.vue?vue&type=template&id=4872a20f&scoped=true"
import script from "./teaDynamic.vue?vue&type=script&lang=js"
export * from "./teaDynamic.vue?vue&type=script&lang=js"
import style0 from "./teaDynamic.vue?vue&type=style&index=0&id=4872a20f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872a20f",
  null
  
)

export default component.exports